import React, {useEffect, useState} from "react";
import {Editor} from "primereact/editor";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Panel} from 'primereact/panel';
import {Divider} from 'primereact/divider';
import {CategoryService} from "../../../service/CategoryService";
import {LabelService} from "../../../service/LabelService";
import {Link} from "react-router-dom";
import GeneralUtils from "../../../utils/GeneralUtils";
import {SubcategoryService} from "../../../service/SubcategoryService";
import {MultiSelect} from 'primereact/multiselect';

const Basic = (props) => {
    const {course, setCourse} = props;
    const [data, setData] = useState(course);

    const instructionalLevel = [
        {name: 'Başlangıç Düzeyi'},
        {name: 'Orta Düzey'},
        {name: 'Uzman Düzeyi'},
        {name: 'Tüm Düzeyler'}
    ];
    const [category, setCategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [label, setLabel] = useState([]);
    const [selectedLabels, setSelectedLabels] = useState([]);

    const categoryService = new CategoryService();
    const subcategoryService = new SubcategoryService();
    const labelService = new LabelService();


    useEffect(() => {
        categoryService.findAll().then(response => setCategory(response));
        labelService.findAll().then(response => setLabel(response));
    }, []);

    useEffect(() => {
        setData(course);
        if (course.courseHasLabelList && course.courseHasLabelList.length > 0) {
            setSelectedLabels(course.courseHasLabelList.map(chl => chl.label));
        }
    }, [course]);

    // Load subcategory list when category changes
    useEffect(() => {
        if (data.category && data.category.id) {
            subcategoryService.findByCategoryId(data.category.id).then(response => {
                setSubcategory(response);
            });
        } else {
            setSubcategory([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.category?.id]);

    useEffect(() => {
        if (data !== course) {
            setCourse(data);
        }
    }, [data]);

    // useEffect(() => {
    //     labelService.findBySubcategoryId(data.subcategory.id).then(response => setLabel(response));
    // }, [data.subcategory]);

    // const search = (event) => {
    //     // Timeout to emulate a network connection
    //     setTimeout(() => {
    //         let _filteredLabels;
    //
    //         if (!event.query.trim().length) {
    //             _filteredLabels = [...label];
    //         }
    //         else {
    //             _filteredLabels = label.filter((el) => {
    //                 return el.title.toLowerCase().startsWith(event.query.toLowerCase());
    //             });
    //         }
    //
    //         setFilteredLabels(_filteredLabels);
    //     }, 250);
    // }


    const handleChange = (e) => {
        const {name, value} = e.target;
        setData((prevData) => ({...prevData, [name]: value}));
        // setCourse({...data, [name]: value});
    };

    const handleChangeEditor = (e) => {
        const value = e.htmlValue;
        setData((prevData) => ({...prevData, description: value}));
        // setCourse({...data, description: value});
    }

    const handleChangeLabel = (e) => {
        setSelectedLabels(e.value);
        const courseHasLabelList = e.value.map((label, index) => ({label: label, isPrimary: (index === 0)}));
        setData((prevData) => ({...prevData, courseHasLabelList: courseHasLabelList}));
    }

    const header = (
        <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
            </span>
    );

    return (
        <Panel header="Kurs Açılış Sayfası">
            <div className="flex flex-column gap-2 mb-2">
                <label htmlFor="title" className="font-bold">Kurs başlığı</label>
                <InputText name="title" value={data.title} onChange={handleChange}
                           id="title" aria-describedby="title-help" type="text" placeholder="---Kurs başlığını girin.---"
                           className="inputtext p-inputtext-sm"/>
                <small id="title-help">Başlığınız ilgi çekici, bilgilendirici ve arama için uygun
                    olmalıdır.</small>
            </div>

            <div className="flex flex-column gap-2 mb-2">
                <label htmlFor="headline" className="font-bold">Kurs alt başlığı</label>
                <InputText name="headline" value={data.headline} onChange={handleChange}
                           id="headline" aria-describedby="headline-help" type="text"
                           placeholder="---Kurs alt başlığını girin.---" className="inputtext p-inputtext-sm"/>
                <small id="headline-help">Konuyla ilgili 1 veya 2 anahtar kelime kullanın ve kursunuzun
                    içeriğindeki en önemli 3-4 alandan bahsedin.</small>
            </div>

            <div className="flex flex-column gap-2 mb-2">
                <label htmlFor="description" className="font-bold">Kurs açıklaması</label>
                <Editor name="description" value={data.description} onTextChange={handleChangeEditor}
                        id="description"
                        // headerTemplate={header}
                        style={{height: '320px'}}/>
            </div>
            <div className="flex flex-column gap-2 mb-2">
                <label htmlFor="instructionalLevel" className="font-bold">Temel bilgiler</label>
                <div className="flex flex-row gap-2">
                    <Dropdown name="instructionalLevelObject" value={data.instructionalLevelObject} onChange={handleChange}
                              id="instructionalLevelObject"
                              options={instructionalLevel} optionLabel="name" placeholder="---Düzey Seçin---"
                              className="w-full md:w-14rem p-inputtext-sm"/>

                    <Dropdown name="category" value={data.category} onChange={handleChange}
                              id="category" dataKey="id"
                              options={category} optionLabel="title" placeholder="---Kategori Seçin---"
                              className="w-full md:w-14rem p-inputtext-sm"/>

                    {data.category && (
                        <Dropdown name="subcategory" value={data.subcategory} onChange={handleChange}
                                  id="subcategory" dataKey="id"
                                  options={subcategory} optionLabel="title"
                                  placeholder="---Alt Kategori Seçin---"
                                  className="w-full md:w-14rem p-inputtext-sm"/>
                    )}
                </div>
            </div>

            <div className="flex flex-column gap-2 mb-2">
                <label htmlFor="label" className="font-bold">Kursunuzda temel olarak ne öğretiliyor?</label>
                <div className="card p-fluid mt-0 noborder">

                    <MultiSelect optionLabel="title" value={selectedLabels} onChange={handleChangeLabel} options={label}
                                 dataKey="id" filter maxSelectedLabels={5} placeholder="---ör. Manzara Fotoğrafçılığı---"/>
                    {/*<AutoComplete field="title" multiple value={selectedLabels} suggestions={filteredLabels} completeMethod={search} onChange={handleChangeLabel}*/}
                    {/*              placeholder="---ör. Manzara Fotoğrafçılığı---"/>*/}
                </div>
            </div>

            {/*<Divider><label>Kurs Görüntüsü</label></Divider>*/}
            {/*<div className="flex flex-row gap-2">*/}
            {/*    <FileUploader type="image" name="image" accept=".gif,.jpg,.jpeg,.png" onUpload={file => setImageFile(file)} file={imageFile}*/}
            {/*                  label="Kurs görüntünüzü buraya yükleyin. Görüntünün kabul edilmesi için kurs görüntüsü kalite standartlarımızı karşılaması gerekir.*/}
            {/*        Önemli yönergeler: 750x422 piksel; .jpg, .jpeg,. gif veya .png. Ayrıca görüntü, metin içermemelidir."/>*/}
            {/*</div>*/}

            {/*<Divider> <label>Kurs Tanıtım Videosu</label></Divider>*/}
            {/*<div className="flex flex-row gap-2">*/}
            {/*    <FileUploader type="video" name="video" accept=".avi,.mpg,.mpeg,.flv,.mov,.m2v,.m4v,.mp4,.rm,.ram,.vob,.ogv,.webm,.wmv" onUpload={file => setVideoFile(file)} file={videoFile}*/}
            {/*                  label="Tanıtım videonuz, öğrencilerin kursunuzda neler öğreneceklerini ön izlemesini sağlayan hızlı ve ilgi çekici bir yöntemdir.*/}
            {/*            İyi hazırlanmış bir tanıtım videonuz varsa kursunuza katılmayı düşünen öğrencilerin kursa kaydolması daha olasıdır."/>*/}
            {/*</div>*/}

            <Divider> <label className="font-bold">Eğitmen profili</label></Divider>

            <Link to={`/instructorInfo/${GeneralUtils.getUser().id}`}>
                <div className="flex flex-row gap-2 align-items-center mb-2">

                    <div className="team-details-thumb">
                        <div className="thumbnail">
                            {GeneralUtils.getUser().image200h ?
                                <img src={GeneralUtils.getUser().image200h} alt="Image" width="60" className="instructor-image"
                                     // onError={(e) => e.target.src = "/icons/user-empty2.png"}
                                />
                                :  <img className="instructor-image" src="/archive/icons/user-empty2.png" alt="instructor-image" width="60"/>}
                        </div>
                    </div>

                    <p style={{color: 'var(--highlight-text-color)', fontWeight: "600", marginBottom: "30px"}}>
                        {GeneralUtils.getUser().title}
                    </p>
                </div>
            </Link>
        </Panel>
    )
};

export default Basic;
